<template>
  <div>
    <h1 class="container text-white">
      Our Services
    </h1>
    <div class="spacer" />
    <div class="special-bg engine-bg">
    <div class="justify-content-around flex container text-white">
      <div v-for="item in images" :key="item.id" class="col-3 super-box" :style="{'background-image':'url(' + item.img + ')'}">
        <h4>
          {{item.title}}
        </h4>
        <p class="text-justify">
          {{item.description}}
        </p>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Images from '@/assets/json/services-data.json'
export default {
  name: 'services',
  computed: {
    images () {
      return Images.images.map(function (item) {
        var miniObject = {
          id: item.id,
          img: '',
          title: item.title,
          description: item.description
        }
        miniObject.img = require('@/assets/services/' + item.img)
        return miniObject
      })
    }
  }
}
</script>
<style lang="postcss">
  h4 {
    position: relative;
  }
  .super-box {
    border-color: white;
    border-style: solid;
    border-radius: 0.25rem;
    border-width:1px;
    margin:1em;
    padding:1em;
    background-position:center;
    background-repeat:no-repeat;
    background-color:rgba(0, 0, 0, 0.9);
  }
  .engine-bg {
    background-image:url(../assets/backgrounds/enginebg.jpg) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Services.vue